import { addMinutes, format } from 'date-fns';

export const getBadgeTime = () => {
  const newTime = addMinutes(new Date(), 15);

  return format(newTime, 'HH:mm');
};
